module.exports = __webpack_public_path__ + "img/card_payok.f0515db5.png";